import { useMsal } from "@azure/msal-react";
import { useSignInState } from "../Components/signInState";
import { useState } from "react";
import { checkAccessTokenExpiry } from "../Helpers/utils";

const useRevealHeaders = () => {
    const { inProgress, accounts, instance } = useMsal();
    const { signInState } = useSignInState();
    const [ headers, setHeaders ] = useState<{ [key: string]: string }>({});

    const getRevealHeaders = async () => {
        const currentCustomerTid = signInState.customerInfo.find((customer: { CustomerID: number; }) => customer.CustomerID === signInState.currentCustomerID)?.TenantID
        let currentAccount = accounts.find(account => account.tenantId === currentCustomerTid);
        if (!currentAccount && currentCustomerTid && accounts.length) {
            currentAccount = accounts[0];
        }
        if (inProgress === 'none' && currentAccount && currentCustomerTid) {
            let accessToken;

            try {
                const silentResult = await instance.acquireTokenSilent({
                    scopes: [`api://${process.env.REACT_APP_CLIENT_APP_ID}/AppUser`],
                    authority: `https://login.microsoftonline.com/${currentAccount.tenantId}`,
                    account: currentAccount,
                    forceRefresh: true
                });
                accessToken = silentResult.accessToken;
            } catch (error) {
                if ((error as any).name === "InteractionRequiredAuthError") {
                    const interactiveResult = await instance.acquireTokenPopup({
                        scopes: [`api://${process.env.REACT_APP_CLIENT_APP_ID}/AppUser`],
                        authority: `https://login.microsoftonline.com/${currentAccount.tenantId}`,
                        account: currentAccount,
                    });
                    accessToken = interactiveResult.accessToken;
                } else {
                    throw error;
                }
            }

            const expiryTime = await checkAccessTokenExpiry(accessToken);
            const currentTime = Math.floor(Date.now() / 1000);
            const timeUntilExpiry = expiryTime - currentTime;
            // Schedule the next refresh 4 minutes before expiry just as an example
            const refreshTimeout = (timeUntilExpiry - 240) * 1000;
            setTimeout(getRevealHeaders, refreshTimeout);
            
            const newHeaders: { [key: string]: string } = {
                "x-customertid": currentCustomerTid,
                "Authorization": `Bearer ${accessToken}`
            };
            setHeaders(newHeaders);
            return newHeaders;
        }
        setHeaders({});
        return {};
    };

    return { headers, getRevealHeaders };
}

export default useRevealHeaders;